import React, { useState, useEffect } from 'react';
import { getHousekeeperById } from '../api/housekeeperApi';
import './IdCardImagePage.css';

// 解析 id_card_url（JSON 数组 [人像面, 国徽面]）
const parseIdCardUrls = (raw) => {
  const result = ['', ''];
  if (raw) {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        result[0] = parsed[0] || '';
        result[1] = parsed[1] || '';
      }
    } catch (e) { /* 非 JSON，忽略 */ }
  }
  return result;
};

export default function IdCardImagePage({ id, navigateTo }) {
  const [frontUrl, setFrontUrl] = useState('');
  const [backUrl, setBackUrl] = useState('');
  const [previewUrl, setPreviewUrl] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await getHousekeeperById(id);
        const [front, back] = parseIdCardUrls(res.data && res.data.id_card_url);
        if (!cancelled) {
          setFrontUrl(front);
          setBackUrl(back);
        }
      } catch (e) {
        if (!cancelled) alert('加载失败');
      }
    })();
    return () => { cancelled = true; };
  }, [id]);

  return (
    <div className="idcard-page">
      <div className="idcard-title">身份证原图</div>
      <div className="idcard-content">
        <div className="idcard-block">
          <div className="idcard-label">人像面</div>
          {frontUrl
            ? <img className="idcard-img" src={frontUrl} alt="人像面" onClick={() => setPreviewUrl(frontUrl)} />
            : <div className="idcard-empty"></div>}
        </div>
        <div className="idcard-block">
          <div className="idcard-label">国徽面</div>
          {backUrl
            ? <img className="idcard-img" src={backUrl} alt="国徽面" onClick={() => setPreviewUrl(backUrl)} />
            : <div className="idcard-empty"></div>}
        </div>
      </div>
      <div className="action-bar">
        <button className="action-btn" onClick={() => navigateTo('detail', { id })}>返回</button>
      </div>

      {previewUrl && (
        <div className="image-preview-overlay" onClick={() => setPreviewUrl('')}>
          <img className="image-preview-img" src={previewUrl} alt="预览" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </div>
  );
}